import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";

import HomeHeader from "../layout/HomeHeader/HomeHeader.component";

import { useTranslation } from "react-i18next";

import HomePage from "../pages/home/Home.page";
import DemoPage from "../pages/demo/Demo.page";
import Login from "../pages/login/login.page";
import { store } from "../redux/store";
import { addError } from "../redux/layout/layoutActions";
import { signOutSuccess } from "../redux/user/userActions";
import { useEffect } from "react";

function PublicNavigator({ isSessionExpired }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (isSessionExpired) {
      store.dispatch(addError(t("loginpage.sessionExpired")));
      store.dispatch(signOutSuccess())
    }
  }, [isSessionExpired, t]);  // Added missing dependencies

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/login" element={<><HomeHeader /><Login /></>} />        
          <Route 
            path="*" 
            element={
              isSessionExpired ? <Navigate to="/login" replace /> : <Navigate to="/" replace />
            } 
          />
        </Routes>
      </main>
    </div>
  );
}

export default PublicNavigator; 